class WorkbookTab implements ITabOrWidget {
    tabOrWidget = TabOrWidgetEnum.Tab;

    workbookConfig: WorkbookConfig;
    id: KnockoutObservable<number>;
    name: KnockoutObservable<string>;
    tabType: KnockoutObservable<TabTypeEnum>;
    widgetType: KnockoutObservable<WidgetType>;
    widget: IWidget;
    widgetContent: any;
    isDefaultTab: KnockoutComputed<boolean>;
    isActiveTab: KnockoutObservable<boolean>;
    order: KnockoutObservable<number>;
    filters: KnockoutObservableArray<Filter>;

    optionsDiv: JQuery<HTMLElement>;

    reportDisplayName: KnockoutObservable<string>;

    tabConfig: WorkbookTabConfig;

    tabContent: any;
    icon: KnockoutComputed<string>;
    //When a filter or something changed, then the needs to be refreshed
    forceRefresh: KnockoutObservable<boolean>;

    /**Used only to bind at the settings tab*/
    itemConfig: KnockoutObservable<BaseItemConfig> = ko.observable(null);
    /** itemConfig converted to ReportConfig */
    get reportConfig() { return this.itemConfig() instanceof ReportConfig ? this.itemConfig() as ReportConfig : null; }

    drilldownManager: DrilldownManager;

    /**Widget that is requesting the detail*/
    detailingWidget: DetailWidget;

    constructor(data: any, workbook: WorkbookConfig) {
        this.workbookConfig = workbook;
        this.id = ko.observable(data.id);
        this.name = ko.observable(data.name);
        this.tabType = ko.observable(data.tabType);
        this.widgetType = ko.observable(data.widgetType);
        this.order = ko.observable(data.order);

        let filtersVM = createInstances(Filter, data.filters as Array<any>);
        this.filters = ko.observableArray(filtersVM);
        this.isDefaultTab = ko.computed(function (this: WorkbookTab) {
            return this.workbookConfig.defaultTabId() === this.id();
        }, this);
        this.isActiveTab = ko.observable(data.isActiveTab);
        this.isActiveTab.subscribe((value) => {
            if (value) {
                this.setActiveTab();
            }
        })

        this.reportDisplayName = ko.observable(data.reportDisplayName);

        this.drilldownManager = new DrilldownManager(data.drilldownId, data.drilldownList, this);

        this.forceRefresh = ko.observable(false);
        this.detailingWidget = new DetailWidget();
        this.optionsDiv = null;

        this.tabConfig = new WorkbookTabConfig(data.tabConfig, this);

        this.icon = ko.computed(function (this: WorkbookTab) {
            switch (this.tabType()) {
                case TabTypeEnum.Chart:
                case TabTypeEnum.ChartDesigner:
                    return "equalizer";
                case TabTypeEnum.Dashboard:
                    return "dashboard";
                case TabTypeEnum.Report:
                case TabTypeEnum.ReportDesigner:
                    switch (this.widgetType()) {
                        case WidgetType.Pivot:
                            return "pivot_table_chart";
                    }
                    return "list_alt";
            }
        }, this);
    }

    refresh() {
        if (this.tabType() === TabTypeEnum.Dashboard) {
            this.dashboard.refresh();
        }
        else {
            BaseWidget.refreshWidget(this);
        }
    }

    getWidgetData(callback: (result: any, error: boolean, errorMessage: string) => void, resetDrilldown?: boolean) {
        let self = this;
        let submitObject = this.getBaseSubmitObject();

        submitObject.resetDrilldown = this.workbookConfig.isPrinting || this.workbookConfig.isExcelPrinting ? false : (resetDrilldown ?? true);
        if (!submitObject.resetDrilldown) {
            submitObject.drilldownId = self.drilldownManager.activeDrilldownId;
        }
        if (this.detailingWidget.hasDetailing()) {
            this.detailingWidget.setSubmitObj(submitObject, this);            
        }

        let o = {
            url: urlConfigs.tabs + "GetTab",
            data: submitObject,
            dataType: "json",
            async: true,
            showIndicator: false,
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            if (self.tabType() !== TabTypeEnum.Dashboard) {
                if (data.filters) {
                    let filtersVM = createInstances(Filter, data.filters as Array<any>);
                    self.filters(filtersVM);
                }

                let error = false;
                if (data.error) {
                    error = true;
                }
                callback(data, error, data.error);
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to get workbook tab`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    private _dashboard: Dashboard = null;
    get dashboard() {

        if (!this._dashboard && this.tabType() === TabTypeEnum.Dashboard) {
            this.getDashboard();
        }

        return this._dashboard;
    }
    get isDashboardLoaded() { return this._dashboard !== null; }

    private getDashboard() {
        let self = this;
        let submitObject = this.getBaseSubmitObject() as any;
        submitObject.isPrinting = workbook.workbookConfig?.isPrinting || workbook.workbookConfig?.isExcelPrinting;

        let o = {
            url: urlConfigs.dashboard + "GetDashboardStructure",
            data: submitObject,
            dataType: "json",
            async: false,

        } as RequestServerParams;
        o.successFunction = function (data, e) {
            if (data.filters) {
                let filtersVM = createInstances(Filter, data.filters as Array<any>);
                self.filters(filtersVM);
            }

            self._dashboard = new Dashboard(data, self);
        }.bind(this);
        o.failureFunction = function (textStatus, failureText, errorItem: IError) {
            errorItem.userMessage = `Failed to get dashboard`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);
        };

        irGlobal.requestServer(o);
    }

    saveTabConfig(callback: (data: any) => void = null) {
        let o = {
            url: urlConfigs.tabs + "UpdateTabSettings",
            data: {// getBaseSubmitObject ??
                workbookId: this.workbookConfig.workbookId(),
                tabId: this.id(),
                backgroundColor: this.tabConfig.backgroundColor(),
                fontColor: this.tabConfig.fontColor(),
                hiddenTab: this.tabConfig.hiddenTab(),
                name: this.name()
            },
            dataType: "json",
            async: false,

        } as RequestServerParams;

        o.successFunction = function (data) {
            if (callback) {
                callback(data)
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save workbook tab settings`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    setDefaultTab(showMessage: boolean = true) {
        let o = {
            url: urlConfigs.tabs + "SetDefaultTab",
            data: {
                workbookId: this.workbookConfig.workbookId(),
                tabId: this.id()
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (this: WorkbookTab, data) {
            this.workbookConfig.defaultTabId(data ? this.id() : 0);
            if (showMessage) {
                DevExpress.ui.notify(data ? `'${this.name()}' set as default` : `'${this.name()}' unset as default`);
            }
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save default workbook tab`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    getBaseSubmitObject(): BaseSubmitObjectForWorkbook {
        return new BaseSubmitObjectForWorkbook(this);
    }

    private setActiveTab() {
        let o = {
            url: urlConfigs.tabs + "SetActiveTab",
            data: {
                newActiveTabId: this.id(),
                workbookId: this.workbookConfig.workbookId()
            },
            dataType: "json",
            async: true,
            showIndicator: false,
        } as RequestServerParams;
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save active workbook tab`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };
        irGlobal.requestServer(o);
    }

    async configureResizableDraggable() {
        if (this.tabType() === TabTypeEnum.Dashboard) {
            this.dashboard.configureResizableDraggable();
        }
    }

    print() {
        if (this.tabType() === TabTypeEnum.Dashboard) {
            this.dashboard.print();
        }
        else {
            this.drilldownManager.getActiveWidget().print();
        }
    }

    exportToPDF(isLandscape: boolean, templateId: number) {
        if (this.tabType() === TabTypeEnum.Dashboard) {
            this.dashboard.exportToPDF(isLandscape, templateId);
        }
        else {
            this.drilldownManager.getActiveWidget().exportToPDF(isLandscape, templateId);
        }
    }

    exportToXLSX(withoutHeaders: boolean) {
        if (this.tabType() !== TabTypeEnum.Dashboard) {
            this.drilldownManager.getActiveWidget().exportToXLSX(withoutHeaders);
        }
    }

    exportToCSV(withoutHeaders: boolean) {
        if (this.tabType() !== TabTypeEnum.Dashboard) {
            this.drilldownManager.getActiveWidget().exportToCSV(withoutHeaders);
        }
    }

    private static popoverComponent: Ir.Components.Workbook.Settings.WorkbookTabsPopover.IWorkbookTabsPopover = null;
    static showTabsPopover($target, onSelect: (item) => void, title?: string) {
        if (WorkbookTab.popoverComponent == null) {
            let $popover = $(`<workbook-tabs-popover params="config: $data"></workbook-tabs-popover>`);
            $popover.appendTo('body');
            ko.applyBindings({
                callback(component: Ir.Components.Workbook.Settings.WorkbookTabsPopover.IWorkbookTabsPopover) {
                    WorkbookTab.popoverComponent = component;
                    WorkbookTab.popoverComponent.show($target, onSelect, title);
                }
            } as Ir.Components.Workbook.Settings.WorkbookTabsPopover.IWorkbookTabsPopoverParams, $popover[0]);
        }
        else {
            WorkbookTab.popoverComponent.show($target, onSelect, title);
        }
    }

    static getTabIcon(type: TabTypeEnum, widgetType: WidgetType): string {
        switch (type) {
            case TabTypeEnum.Report:
                if (widgetType == WidgetType.Pivot) {
                    return "pivot_table_chart";
                }

                return "list_alt";
            case TabTypeEnum.Chart:
                return "equalizer";
            case TabTypeEnum.Dashboard:
                return "dashboard";
            default:
                return "";
        }
    }
}